import React from 'react';
import { Formik, Form } from 'formik';

import { JOB_TYPE_YARD_SIGN_SETUP, JOB_TYPE_CODEBOX_INSTALL } from 'common/jobConstants';

import { createFormValidationFn } from 'client/helpers/formikHelpers';

import { SR_CHECKBOX_THEME_BOX } from 'client/components/Checkbox';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrBox from 'client/components/SrBox';
import SrPartnerListingWithdrawModal from 'client/components/SrPartnerListingWithdrawCard/SrPartnerListingWithdrawModal';

const formFields = [
  {
    id: 'itemsToUninstall',
    type: 'multiple_choice',
    title: 'Choose items:',
    properties: {
      enableResetOption: true,
      choices: [
        {
          label: 'Yard Sign',
          value: JOB_TYPE_YARD_SIGN_SETUP,
        },
        {
          label: 'Code Box',
          value: JOB_TYPE_CODEBOX_INSTALL,
        },
      ],
      fieldType: SR_CHECKBOX_THEME_BOX,
      autoFitWidth: '300px',
    },
    validations: ['required', 'nonEmptyArray'],
  },
];

const SrPartnerListingWithdrawChooseItemsModal = ({ onClose, onSubmit }) => {
  return (
    <Formik
      onSubmit={onSubmit}
      validate={(formValues) => {
        return createFormValidationFn(formFields)(formValues);
      }}
      render={(formikBag) => {
        return (
          <SrPartnerListingWithdrawModal
            disabled={!formikBag.isValid}
            onClose={onClose}
            onConfirm={formikBag.handleSubmit}
          >
            <Form>
              <SrBox textAlign="center" margin="0 0 20px">
                <img
                  width="82px"
                  height="auto"
                  src="/images/uninstall-illustration.svg"
                  alt="uninstall"
                />
              </SrBox>
              <SrBox margin="0 0 40px">
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                    theme={SR_FIELD_THEME_ADOBE}
                  />
                ))}
              </SrBox>
            </Form>
          </SrPartnerListingWithdrawModal>
        );
      }}
    />
  );
};

SrPartnerListingWithdrawChooseItemsModal.displayName = 'SrPartnerListingWithdrawChooseItemsModal';

export default SrPartnerListingWithdrawChooseItemsModal;
